import { v4 as uuidv4 } from "uuid";
import { addGameActivity, saveHistoryTaking } from "../../redux/dispatchers";

export const renderReply = (resultObject) => {
  const { id } = resultObject;

  // save the asked question in user activity
  addGameActivity("history", id);

  // set history messages
  if (resultObject.stat === "1") {
    saveHistoryTaking({
      id: uuidv4(),
      isCurrentUser: false,
      content: resultObject.defaultAnswer || "Not relevant.",
      timestamp: +new Date(),
    });
  } else {
    if (!!resultObject.answer.contents)
      saveHistoryTaking({
        id: uuidv4(),
        isCurrentUser: false,
        content: resultObject.answer.contents,
        timestamp: +new Date(),
      });
    if (!!resultObject.answer.link && resultObject.answer.link.length > 0) {
      saveHistoryTaking({
        id: uuidv4(),
        isCurrentUser: false,
        content: `<a href="${resultObject.answer.link[0]}" target="_blank">Click here to open the attachment.</a>`,
        timestamp: +new Date(),
      });
    }
  }
};

export { default as Interview } from "./interview";
